import type { PatternProps } from "./shared";

export function PlusPattern({ color, salt }: PatternProps) {
	/** Render */
	return (
		<defs>
			<pattern
				id={`${salt}-plusPattern`}
				patternUnits="userSpaceOnUse"
				width="26.25"
				height="26.25"
			>
				<path
					d="M13.125,7 v12.25 M7,13.125 h12.25"
					stroke={color}
					strokeWidth="1.75"
					strokeLinecap="round"
				/>
			</pattern>
		</defs>
	);
}
